import { bonusesReducer } from './reducers';

export default {
  bonuses: bonusesReducer
};
